module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "weui-form-preview"
  }, [_c('div', {
    staticClass: "weui-form-preview__hd"
  }, [_c('label', {
    staticClass: "weui-form-preview__label"
  }, [_vm._v(_vm._s(_vm.previewObj.label))]), _vm._v(" "), _c('em', {
    staticClass: "weui-form-preview__value"
  }, [_vm._v(_vm._s(_vm.previewObj.value))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-form-preview__bd"
  }, [_vm._l((_vm.previewObj.items), function(item) {
    return [_c('div', {
      staticClass: "weui-form-preview__item"
    }, [_c('label', {
      staticClass: "weui-form-preview__label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "weui-form-preview__value"
    }, [_vm._v(_vm._s(item.value))])])]
  })], true), _vm._v(" "), _c('div', {
    staticClass: "weui-form-preview__ft"
  }, [(_vm.previewObj.assistCbText) ? _c('a', {
    staticClass: "weui-form-preview__btn weui-form-preview__btn_default",
    on: {
      "click": function($event) {
        _vm.callbackFun(_vm.previewObj.assistCb)
      }
    }
  }, [_vm._v(_vm._s(_vm.previewObj.assistCbText))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "weui-form-preview__btn weui-form-preview__btn_primary",
    on: {
      "click": function($event) {
        _vm.callbackFun(_vm.previewObj.cb)
      }
    }
  }, [_vm._v(_vm._s(_vm.previewObj.cbText))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-91244fc8!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/preview/preview.vue
// module id = 276
// module chunks = 0